// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vld-overlay[data-v-1e9bb758]{position:relative}h2[data-v-1e9bb758]{font-family:Circular Std;font-style:normal;font-weight:700;font-size:26px;line-height:33px;color:#000}.loading-component[data-v-1e9bb758] .no-bg .vld-background{background:none!important}", ""]);
// Exports
module.exports = exports;
